/** UK checkout delivery options (GBP). */
export const DELIVERY_STANDARD_GBP = 3.99;
export const DELIVERY_PRIORITY_GBP = 6.99;

/** @typedef {'standard' | 'priority'} DeliveryOption */

/** @param {DeliveryOption | string | undefined} option */
export function deliveryShippingGbp(option) {
  return option === "priority" ? DELIVERY_PRIORITY_GBP : DELIVERY_STANDARD_GBP;
}

export const DELIVERY_CHECKOUT_COPY =
  "Standard UK delivery is £3.99. Priority or tracked delivery is available at checkout if you want extra peace of mind.";

export const DELIVERY_OPTIONS = [
  {
    id: /** @type {const} */ ("standard"),
    label: "Standard UK delivery",
    priceGbp: DELIVERY_STANDARD_GBP,
    copy: "Charged separately at checkout. Usually dispatched within 1 to 3 working days.",
  },
  {
    id: /** @type {const} */ ("priority"),
    label: "Priority / tracked delivery",
    priceGbp: DELIVERY_PRIORITY_GBP,
    copy: "Charged separately at checkout. Prepared first where possible on a faster tracked service.",
  },
];
